import React from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import { businessCity, businessZipcode, businessKecamatan } from 'actions';
import {
  goToStep,
  resetKybCityDropdown,
  resetKybKecamatanDropdown,
  resetKybZipcodeDropdown,
} from 'actions/kyb';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import * as clevertapKyb from 'clevertap/kyb';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'This field is required';
  } else if (values.name.trim().length < 1) {
    errors.name = 'This field is required';
  }
  if (!values.address) {
    errors.address = 'This field is required';
  } else if (values.address.trim().length < 1) {
    errors.address = 'This field is required';
  }
  if (!values.province) {
    errors.province = 'This field is required';
  }
  if (!values.city) {
    errors.city = 'This field is required';
  }
  if (!values.kecamatan) {
    errors.kecamatan = 'This field is required';
  }
  if (!values.zipcode) {
    errors.zipcode = 'This field is required';
  }

  return errors;
};

const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        autoComplete="randomStuffToDisableAutocomplete"
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
        onKeyPress={e => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

const textareaField = field => {
  return (
    <div className={`${styles['textarea-field']}`}>
      <textarea
        {...field.input}
        autoComplete="randomStuffToDisableAutocomplete"
        maxLength={field.maxLength}
        className={`form-control ${styles['input-style']} ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
  <div>
    <div>
      <select
        {...input}
        className={`form-control ${styles['input-style']} ${
          touched && error ? styles['input-error'] : ''
        }`}
        autoComplete="randomStuffToDisableAutocomplete"
      >
        {children}
      </select>
      <small className={styles.error}>{touched ? error : ''}</small>
    </div>
  </div>
);

const popover = (
  <Popover id="popover-address">
    To ensure the success of your E-Wallet application, make sure your address
    includes your building name, floor (if applicable), street address, and your
    RT/RW. <br />
    e.g. Malioboro Tower, Ruko Istana Kebon Jeruk, Jl. Milantro Raya No. 87
    RT.1/RW.5
  </Popover>
);

let BusinessInfoForm = class BusinessInfoForm extends React.Component {
  constructor(props) {
    super(props);
    if (props.data.kybForm.kybData) {
      this.initializeForm();
    }
  }

  componentDidMount() {
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
    } = this.props.data.kybForm.kybData;
    const { appendBusinessOpeningClevertap } = this.props;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
    };
    appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker(
      'KYB Business Information Start',
      clevertapData
    );
  }

  initializeForm() {
    const { kybData } = this.props.data.kybForm;
    const initData = {
      name: kybData.name,
      address: kybData.address,
      province: kybData.province,
      city: kybData.city,
      kecamatan: kybData.kecamatan,
      zipcode: kybData.postal_code,
    };
    this.props.initialize(initData);
  }

  goBack = () => {
    const { editMode } = this.props.data.kybForm;
    if (editMode) {
      this.props.dispatch(goToStep(5));
    } else {
      this.props.dispatch(goToStep(1));
    }
  };

  handleProvinceChange = e => {
    const province = e.target.value;
    const provinceId = this.props.businessProvinceState[province];
    this.props.dispatch(resetKybCityDropdown());
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'city', null));
    this.props.dispatch(change('BusinessInfoForm', 'kecamatan', null));
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (provinceId !== undefined && provinceId !== null) {
      this.props.dispatch(businessCity(provinceId));
    }
  };

  handleCityChange = e => {
    const city = e.target.value;
    const cityId = this.props.businessCityState[city];
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'kecamatan', null));
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (cityId !== undefined && cityId !== null) {
      this.props.dispatch(businessKecamatan(cityId));
    }
  };

  handleKecamatanChange = e => {
    const kecamatan = e.target.value;
    const kecamatanId = this.props.businessKecamatanState[kecamatan];
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (kecamatanId !== undefined && kecamatanId !== null) {
      this.props.dispatch(businessZipcode(kecamatanId));
    }
  };

  render() {
    const {
      handleSubmit,
      valid,
      businessProvinceState,
      businessCityState,
      businessKecamatanState,
    } = this.props;
    const { editMode } = this.props.data.kybForm;
    const provinceIdList = Object.keys(businessProvinceState);
    const cityIdList = Object.keys(businessCityState);
    const kecamatanIdList = Object.keys(businessKecamatanState);
    return (
      <div>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <div className="col-md-8 col-md-offset-2">
            <h2>{editMode ? 'Edit' : 'Add'} your business info</h2>
            <div className={`${styles['business-form']}`}>
              <div className="form-group">
                <label>Business Name</label>
                <Field
                  component={inputField}
                  name="name"
                  autoComplete="randomStuffToDisableAutocomplete"
                  placeholder="Business Name"
                  autoCorrect="off"
                  maxLength="30"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>

              <div className="form-group">
                <label>Business Address</label>
                <OverlayTrigger placement="right" overlay={popover}>
                  <Field
                    component={textareaField}
                    name="address"
                    placeholder="e.g. Malioboro Tower, Ruko Istana Kebon Jeruk, Jl. Milantro Raya No. 87 RT.1/RW.5"
                    maxLength="100"
                  />
                </OverlayTrigger>
              </div>

              <div className="form-group">
                <label>Province</label>
                <Field
                  component={renderSelectField}
                  onChange={this.handleProvinceChange}
                  name="province"
                >
                  <option key={-1} value="">
                    Province
                  </option>
                  {provinceIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="form-group">
                <label>City / Kabupaten</label>
                <Field
                  component={renderSelectField}
                  onChange={this.handleCityChange}
                  name="city"
                >
                  <option key={-1} value="">
                    City / Kabupaten
                  </option>
                  {cityIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="form-group">
                <label>Kecamatan</label>
                <Field
                  component={renderSelectField}
                  onChange={this.handleKecamatanChange}
                  name="kecamatan"
                >
                  <option key={-1} value="">
                    Kecamatan
                  </option>
                  {kecamatanIdList.map((name, index) => (
                    <option value={name} key={index}>
                      {name}
                    </option>
                  ))}
                </Field>
              </div>

              <div className="form-group">
                <label>Postal Code</label>
                <Field component={renderSelectField} name="zipcode">
                  <option key={-1} value="">
                    Postal Code
                  </option>
                  {this.props.businessZipcodeState.map((option, index) => (
                    <option value={option.code} key={index}>
                      {option.code}
                    </option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
          <div className={`col-md-8 col-md-offset-2 ${styles['flex-display']}`}>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-block btn-default ${styles['back-btn']}`}
                type="button"
                onClick={this.goBack}
              >
                Back
              </button>
            </div>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-primary btn-block`}
                disabled={!valid}
                type="submit"
              >
                {editMode ? 'Save Changes' : 'Next'}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
};

BusinessInfoForm = reduxForm({
  form: 'BusinessInfoForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(BusinessInfoForm);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(BusinessInfoForm);
